/* eslint-disable no-useless-constructor */
/* global DeferredMedia */

if (!customElements.get('product-model')) {
  class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    handleMouseMove(evt) {
      if (!this.modelViewer.classList.contains('shopify-model-viewer-ui__disabled')) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }

    /**
     * Reicht die Parameter an DeferredMedia durch.
     *
     * Vorher nahm diese Fassung keine Parameter und rief super.loadContent()
     * ohne Argumente auf. Der Aufruf lbrgtModellStarten -> loadContent(false,
     * false, 'auto') aus assets/media-gallery.js wurde damit verschluckt: es
     * galten die Vorgaben focus=true und pause=true aus assets/main.js. Seit
     * das Modell von selbst laedt, hiess das beim Seitenaufbau Fokussprung ins
     * model-viewer und ein pauseAllMedia() ohne Anlass.
     *
     * @param {boolean} [focus=true] - Fokus nach dem Laden ins Medium setzen.
     * @param {boolean} [pause=true] - Andere Medien anhalten.
     * @param {string} [loadTrigger='click'] - Was das Laden ausgeloest hat.
     */
    loadContent(focus = true, pause = true, loadTrigger = 'click') {
      super.loadContent(focus, pause, loadTrigger);

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this)
        }
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewer = this.querySelector('model-viewer');

      // Shopifys ModelViewerUI startet grundsaetzlich pausiert: sie haengt dem
      // model-viewer die Klasse shopify-model-viewer-ui__disabled an und setzt
      // tabindex auf -1. Erst ein Klick ruft intern play() und gibt das Drehen
      // frei. Solange das Modell erst auf Klick geladen wurde, war dieser Klick
      // ohnehin faellig - seit es von selbst laedt, ist er nur noch im Weg:
      // man klickt einmal ins Leere und kann erst danach ziehen.
      //
      // focusOnPlay steht in der Voreinstellung auf true. Ohne das Ausschalten
      // wuerde play() beim Seitenaufbau den Fokus ins model-viewer ziehen und
      // die Seite dorthin springen lassen.
      this.modelViewerUI = new Shopify.ModelViewerUI(this.modelViewer, { focusOnPlay: false });
      this.modelViewerUI.play();

      this.addEventListener('mousemove', this.handleMouseMove.bind(this));
    }
  }

  customElements.define('product-model', ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this)
      }
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="product-json-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });

    window.ShopifyXR.setupXRElements();
  }
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
